module.exports = __webpack_public_path__ + "assets/img/8e3df85382826a75bd8db9fc3412b3da.png";